import React from 'react';
import {DatasetIdentifier} from "api/model/dataset/datasetModels";
import {useGetDatasetInfo} from "api/api-hooks/datasets-hooks";

interface IDatasetTitleProps {
    identifier: string| DatasetIdentifier | null ;
}

export default function DatasetTitle(props: IDatasetTitleProps) {
    const query = useGetDatasetInfo(props.identifier)

    const loading = query.isLoading || props.identifier == null;

    return <>
        { loading && "Loading..." }

        { query.isError && "Error!" }

        { query.isSuccess && query.data?.toString() }
    </>
}